// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AcquisitionSourceFormController from "./acquisition_source_form_controller"
application.register("acquisition-source-form", AcquisitionSourceFormController)

import ChannelFormController from "./channel_form_controller"
application.register("channel-form", ChannelFormController)

import Components__CalendarController from "./components/calendar_controller"
application.register("components--calendar", Components__CalendarController)

import Components__SimpleTableController from "./components/simple_table_controller"
application.register("components--simple-table", Components__SimpleTableController)

import Components__TurboFrameTabsController from "./components/turbo_frame_tabs_controller"
application.register("components--turbo-frame-tabs", Components__TurboFrameTabsController)

import DocumentQueryController from "./document_query_controller"
application.register("document-query", DocumentQueryController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import OpportunityFiltersController from "./opportunity_filters_controller"
application.register("opportunity-filters", OpportunityFiltersController)

import PaymentFormController from "./payment_form_controller"
application.register("payment-form", PaymentFormController)

import SalesGoalFormController from "./sales_goal_form_controller"
application.register("sales-goal-form", SalesGoalFormController)

import SalesOpportunityWizardController from "./sales_opportunity_wizard_controller"
application.register("sales-opportunity-wizard", SalesOpportunityWizardController)

import Shared__FlashMessagesController from "./shared/flash_messages_controller"
application.register("shared--flash-messages", Shared__FlashMessagesController)

import Shared__SidebarController from "./shared/sidebar_controller"
application.register("shared--sidebar", Shared__SidebarController)

import VehicleFormController from "./vehicle_form_controller"
application.register("vehicle-form", VehicleFormController)
